import React from 'react'

const Logo = () => {

    return (
        <img src="/shublogo.jpg" />
    )
}

export default Logo